import Loadable from "app/components/Loadable";
import { lazy } from "react";
import { PERMISSIONS } from "app/utils/permissions";

const VisitDayList = Loadable(lazy(() => import("./VisitDayList")));
const VisitDayForm = Loadable(lazy(() => import("./VisitDayForm")));

const visitDayRoutes = [
    {
        path: "/VisitDay/VisitDayList",
        element: <VisitDayList />,
        permission: PERMISSIONS.VisitDays.Menu,
    },
    {
        path: "/VisitDay/VisitDayForm",
        element: <VisitDayForm />,
    },
    {
        path: "/VisitDay/VisitDayForm/:visitDayId",
        element: <VisitDayForm />,
    },
];

export default visitDayRoutes;
